import { css } from '@styled-system/css';
import { container, flex, stack } from '@styled-system/patterns';

export function TestThemePage() {
  return (
    <div className={container({ maxW: '6xl', py: 'lg' })}>
      <div className={stack({ gap: 'lg' })}>
        {/* Header */}
        <div className={stack({ gap: 'sm', align: 'center' })}>
          <h1
            className={css({
              fontSize: 'xl',
              fontWeight: 'bold',
              color: 'text.primary',
            })}
          >
            Recop Design System Test
          </h1>
          <p
            className={css({
              fontSize: 'md',
              color: 'text.secondary',
            })}
          >
            Test du nouveau thème basé sur les designs Figma
          </p>
        </div>

        {/* Color Palette */}
        <div className={stack({ gap: 'sm' })}>
          <h2
            className={css({
              fontSize: 'lg',
              fontWeight: 'medium',
              color: 'text.primary',
            })}
          >
            Palette de couleurs
          </h2>

          <div className={flex({ gap: 'xs', wrap: 'wrap' })}>
            {/* Background colors */}
            <div
              className={css({
                p: 'sm',
                bg: 'bg.default',
                border: '1px solid',
                borderColor: 'border.default',
                rounded: 'sm',
              })}
            >
              <div className={css({ fontSize: '2xs', color: 'text.muted' })}>bg.default</div>
            </div>

            <div
              className={css({
                p: 'sm',
                bg: 'bg.surface',
                border: '1px solid',
                borderColor: 'border.default',
                rounded: 'sm',
              })}
            >
              <div className={css({ fontSize: '2xs', color: 'text.muted' })}>bg.surface</div>
            </div>

            <div
              className={css({
                p: 'sm',
                bg: 'bg.elevated',
                border: '1px solid',
                borderColor: 'border.default',
                rounded: 'sm',
              })}
            >
              <div className={css({ fontSize: '2xs', color: 'text.muted' })}>bg.elevated</div>
            </div>

            <div
              className={css({
                p: 'sm',
                bg: 'bg.primary',
                rounded: 'sm',
              })}
            >
              <div className={css({ fontSize: '2xs', color: 'text.inverse' })}>bg.primary</div>
            </div>

            <div
              className={css({
                p: 'sm',
                bg: 'bg.orange',
                rounded: 'sm',
              })}
            >
              <div className={css({ fontSize: '2xs', color: 'text.inverse' })}>bg.orange</div>
            </div>
          </div>
        </div>

        {/* Typography */}
        <div className={stack({ gap: 'sm' })}>
          <h2
            className={css({
              fontSize: 'lg',
              fontWeight: 'medium',
              color: 'text.primary',
            })}
          >
            Typographie
          </h2>

          <div className={stack({ gap: 'xxs' })}>
            <div className={css({ fontSize: 'xl', color: 'text.primary' })}>Extra Large (18px) - Titres principaux</div>
            <div className={css({ fontSize: 'lg', color: 'text.primary' })}>Large (16px) - Titres secondaires</div>
            <div className={css({ fontSize: 'md', color: 'text.primary' })}>Medium (13px) - Texte principal</div>
            <div className={css({ fontSize: 'sm', color: 'text.secondary' })}>
              Medium Small (11px) - Texte secondaire
            </div>
            <div className={css({ fontSize: 'm', color: 'text.muted' })}>Small (10px) - Texte auxiliaire</div>
            <div className={css({ fontSize: '2xs', color: 'text.lowkey' })}>Extra Small (9px) - Labels</div>
          </div>
        </div>

        {/* Cards */}
        <div className={stack({ gap: 'sm' })}>
          <h2
            className={css({
              fontSize: 'lg',
              fontWeight: 'medium',
              color: 'text.primary',
            })}
          >
            Cards et surfaces
          </h2>

          <div className={flex({ gap: 'sm', wrap: 'wrap' })}>
            <div
              className={css({
                p: 'sm',
                bg: 'card.bg',
                border: '1px solid',
                borderColor: 'card.border',
                rounded: 'sm',
                minW: '200px',
              })}
            >
              <div className={css({ fontSize: 'md', color: 'text.primary', mb: 'xxs' })}>Card standard</div>
              <div className={css({ fontSize: 'sm', color: 'text.secondary' })}>
                Contenu de la card avec texte secondaire
              </div>
            </div>

            <div
              className={css({
                p: 'sm',
                bg: 'sidebar.bg',
                border: '1px solid',
                borderColor: 'border.default',
                rounded: 'sm',
                minW: '200px',
              })}
            >
              <div className={css({ fontSize: 'md', color: 'text.primary', mb: 'xxs' })}>Sidebar style</div>
              <div className={css({ fontSize: 'sm', color: 'text.secondary' })}>Style utilisé pour la navigation</div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className={stack({ gap: 'sm' })}>
          <h2
            className={css({
              fontSize: 'lg',
              fontWeight: 'medium',
              color: 'text.primary',
            })}
          >
            Boutons (aperçu statique)
          </h2>

          <div className={flex({ gap: 'sm', wrap: 'wrap' })}>
            <div
              className={css({
                px: 'sm',
                py: 'xs',
                bg: 'bg.primary',
                color: 'text.inverse',
                rounded: 'sm',
                fontSize: 'md',
                fontWeight: 'medium',
              })}
            >
              Primary Button
            </div>

            <div
              className={css({
                px: 'sm',
                py: 'xs',
                bg: 'bg.surface',
                color: 'text.primary',
                border: '1px solid',
                borderColor: 'border.default',
                rounded: 'sm',
                fontSize: 'md',
                fontWeight: 'medium',
              })}
            >
              Secondary Button
            </div>

            <div
              className={css({
                px: 'sm',
                py: 'xs',
                bg: 'transparent',
                color: 'text.accent',
                border: '1px solid',
                borderColor: 'border.accent',
                rounded: 'sm',
                fontSize: 'md',
                fontWeight: 'medium',
              })}
            >
              Outline Button
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
